__turbopack_context__.v({
  "background": "sOXk4G_background",
  "close": "sOXk4G_close",
  "closeIcon": "sOXk4G_closeIcon",
  "container": "sOXk4G_container",
  "content": "sOXk4G_content",
  "contentBlock": "sOXk4G_contentBlock",
  "details": "sOXk4G_details",
  "detailsGroup": "sOXk4G_detailsGroup",
  "header": "sOXk4G_header",
  "imageBlock": "sOXk4G_imageBlock",
  "imageBlockImage": "sOXk4G_imageBlockImage",
  "isVisible": "sOXk4G_isVisible",
  "mktuClassBlock": "sOXk4G_mktuClassBlock",
  "mktuClassBlockText": "sOXk4G_mktuClassBlockText",
  "mktuClasses": "sOXk4G_mktuClasses",
  "postLoader": "sOXk4G_postLoader",
  "title": "sOXk4G_title",
  "valid": "sOXk4G_valid",
  "validText": "sOXk4G_validText",
  "validTextDate": "sOXk4G_validTextDate",
});
